import { useParams, Navigate } from 'react-router-dom';
import { getCollection, getMoviesByIds } from '@/shared/data';
import { MovieCard } from './components/MovieCard';

export function Collection() {
  const { slug = '' } = useParams<{ slug: string }>();
  const c = getCollection(slug);
  if (!c) return <Navigate to="/movieflix" replace />;
  const movies = getMoviesByIds(c.movieIds);
  return (
    <div data-testid="collection-page" data-slug={slug} className="px-4">
      <h1 className="font-serif italic text-2xl text-white mb-1">{c.title}</h1>
      {c.description && <p className="text-white/50 text-sm mb-4">{c.description}</p>}
      <div className="grid grid-cols-2 gap-3">
        {movies.map((m) => (
          <MovieCard key={m.id} movie={m} variant="portrait" />
        ))}
      </div>
    </div>
  );
}
